import App from '@/App';
import Login from '@/router/views/Login';

import Home from '@/router/views/Home/Listar';
import Faq from '@/router/views/Faq/Faq';
import NotificacoesListar from '@/router/views/Notificacoes/Listar';
import DetalharProposta from '@/router/views/Propostas/Detalhar';
import DetalharApolice from '@/router/views/Apolices/Detalhar';
import NovaProposta from '@/router/views/Propostas/Propostas';
import Endossar from "@/router/views/Apolices/Endossar";

import CorretorListar from '@/router/views/Corretores/Listar';
import CorretorCadastrar from '@/router/views/Corretores/Cadastrar';

import OpçõesExtratosListar from '@/router/views/ExtratosRecibos/Listar';

import RecibosPesquisar from '@/router/views/ExtratosRecibos/Recibos/Pesquisar';
import RecibosListar from '@/router/views/ExtratosRecibos/Recibos/Listar';

import ExtratosPesquisar from '@/router/views/ExtratosRecibos/ExtratosEmissaoProducao/Pesquisar';
import ExtratosListar from '@/router/views/ExtratosRecibos/ExtratosEmissaoProducao/Listar';

import TomadorListar from '@/router/views/Tomadores/Listar';
import TomadoresCadastrar from '@/router/views/Tomadores/Cadastrar';
import TomadorDetalhar from '@/router/views/Tomadores/Detalhar';

import TermosDeServico from '@/router/views/TermosDeServico';
import MesaDeTrabalho from '@/router/views/MesaDeTrabalho/Listar';

import MeuPerfil from '@/router/views/Perfis/Eu';

export default [
  {
    path: '/',
    name: 'ConnectionGuard',

    beforeEnter: (to, from, next) => {
      localStorage.clear();
      next({ name: 'Login' });
    },
  },

  { path: '/login/:debugFlag?', name: 'Login', component: Login },
  { path: '/cadastrar', name: 'Cadastrar', component: CorretorCadastrar },
  { path: '/criar-senha/:hash/:email', name: 'Criar Senha', component: Login },
  {
    path: '/bloquear-usuarios/:hash/:email',
    name: 'Bloquear Usuários',
    component: Login,
  },
  {
    path: '/home',
    name: 'Início',
    component: Home,
    meta: { authRequired: true },
  },
  { path: '/faq', name: 'FAQ', component: Faq, meta: { authRequired: true } },
  {
    path: '/mesa-de-trabalho',
    name: 'Mesa de Trabalho',
    component: MesaDeTrabalho,
    meta: { authRequired: true },
  },
  {
    path: '/termos-de-servico',
    name: 'Termos de Serviço',
    component: TermosDeServico,
    meta: { authRequired: true },
  },
  {
    path: '/notificacoes',
    name: 'Notificações',
    component: NotificacoesListar,
    meta: { authRequired: true },
  },

  {
    path: '/corretores/novo',
    name: 'Novo Corretor',
    component: CorretorCadastrar,
    meta: { authRequired: true },
  },
  {
    path: '/corretores',
    name: 'Listar Corretores',
    component: CorretorListar,
    meta: { authRequired: true },
  },

  // Opções de extrato
  {
    path: '/opcoes-extratos',
    name: 'Opções de Extratos',
    component: OpçõesExtratosListar,
    meta: { authRequired: true },
  },

  // Recibos
  {
    path: '/recibos',
    name: 'Recibos',
    component: RecibosPesquisar,
    meta: { authRequired: true },
  },
  {
    path: '/recibos/listar',
    name: 'Listar Recibos',
    component: RecibosListar,
    meta: { authRequired: true },
  },

  // Extratos Emissão/Produção
  {
    path: '/extratos',
    name: 'Extratos',
    component: ExtratosPesquisar,
    meta: { authRequired: true },
  },
  {
    path: '/extratos/listar',
    name: 'Listar Extratos',
    component: ExtratosListar,
    meta: { authRequired: true },
  },

  {
    path: '/tomadores',
    name: 'Consultar Tomadores',
    component: TomadorListar,
    meta: { authRequired: true },
  },
  {
    path: '/tomadores/novo',
    name: 'Novo Tomador',
    component: TomadoresCadastrar,
    meta: { authRequired: true },
  },
  {
    path: '/tomadores/:takerCNPJ/:tab',
    name: 'Informações do Tomador',
    props: true,
    component: TomadorDetalhar,
    meta: { authRequired: true },
  },
  {
    path: '/perfil',
    name: 'Meu Perfil',
    component: MeuPerfil,
    meta: { authRequired: true },
  },
  {
    path: '/proposta/editar/:propostaId/:produtoId',
    name: 'Editar Proposta',
    component: NovaProposta,
    meta: { authRequired: true, formPage: true },
    props: true,
  },
  {
    path: '/proposta/novo',
    name: 'Nova Proposta',
    component: NovaProposta,
    meta: { authRequired: true, formPage: true },
    props: true,
  },
  {
    path: '/proposta/:propostaId/:produtoId',
    name: 'Detalhes da Proposta',
    component: DetalharProposta,
    meta: { authRequired: true },
    props: true,
  },
  {
    path: '/apolice/:apoliceId',
    name: 'Detalhes da Apólice',
    component: DetalharApolice,
    meta: { authRequired: true },
    props: true,
  },
  { path: "/apolice/:apoliceId/endossar/alterar-vigencia-is", name: "Solicitação de Endosso", component: Endossar, meta: { authRequired: true, formPage: true }, props: true }
];



// WEBPACK FOOTER //
// ./src/router/routes.js